import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { supportCallAPI, reportAPI } from '../services/api';

const card = { background:'white', borderRadius:'12px', border:'1px solid #e2e8f0', padding:'16px 20px', marginBottom:'12px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' };
const inp = { border:'1px solid #e2e8f0', borderRadius:'8px', padding:'8px 12px', fontSize:'13px', outline:'none', width:'100%', boxSizing:'border-box' };
const sel = { ...inp };
const btn = { padding:'8px 18px', borderRadius:'8px', border:'none', cursor:'pointer', fontWeight:600, fontSize:'13px' };

const STB_WORK_TYPES = [
  {v:'migration_sub', l:'STB Migration (Sub → Sub)'},
  {v:'migration_lco', l:'STB Migration (LCO → LCO)'},
  {v:'activation', l:'STB Activation'},
  {v:'deactivation', l:'STB Deactivation'},
  {v:'complaint', l:'STB Complaint (Freeze/Channel)'},
  {v:'other', l:'Other'},
];
const BB_COMPLAINT_TYPES = [
  {v:'no_internet', l:'No Internet'},
  {v:'slow_speed', l:'Slow Speed'},
  {v:'disconnection', l:'Disconnection'},
  {v:'intermittent', l:'Intermittent Connection'},
  {v:'other', l:'Other'},
];

const emptyForm = {
  call_category:'', caller_name:'', caller_mobile:'',
  stb_id:'', stb_work_type:'', stb_from:'', stb_to:'',
  bb_username:'', bb_complaint_type:'',
  notes:'', follow_up_needed:false, follow_up_date:'', resolved:true
};

export default function SupportCalls() {
  const { user } = useAuth();
  const isCrm = user?.role === 'crm_staff';
  const canView = ['crm_staff','dist_admin','dist_head','director','tenant_admin','superadmin'].includes(user?.role);

  const [form, setForm] = useState(emptyForm);
  const [submitting, setSubmitting] = useState(false);
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [stats, setStats] = useState(null);
  const [filterCat, setFilterCat] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [toast, setToast] = useState('');
  const [bmsUser, setBmsUser] = useState(null);
  const [bmsLooking, setBmsLooking] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const showToast = (msg) => { setToast(msg); setTimeout(()=>setToast(''),3000); };

  const lookupBmsUser = async (username) => {
    if(!username || username.length < 2) { setBmsUser(null); return; }
    setBmsLooking(true);
    try {
      const r = await reportAPI.bmsLookup(username);
      if(r.data.success) {
        const u = r.data.user;
        setBmsUser(u);
        setForm(p=>({...p,
          caller_name: p.caller_name||u.name,
          caller_mobile: p.caller_mobile||u.mobile,
          bb_username: username
        }));
      } else { setBmsUser(null); }
    } catch(e) { setBmsUser(null); }
    setBmsLooking(false);
  };

  const loadLogs = useCallback(async () => {
    try {
      const r = await supportCallAPI.list({ page, limit:20, category:filterCat||undefined });
      setLogs(r.data.logs||[]);
      setTotal(r.data.total||0);
    } catch(e) { console.error(e); }
  }, [page, filterCat]);

  const loadStats = useCallback(async () => {
    try {
      const r = await supportCallAPI.stats();
      setStats(r.data);
    } catch(e) {}
  }, []);

  useEffect(() => { loadLogs(); loadStats(); }, [loadLogs, loadStats]);

  const handleSubmit = async () => {
    if(!form.call_category) return showToast('Please select Digital or Broadband');
    if(!form.caller_name && !form.caller_mobile) return showToast('Please enter caller name or mobile');
    if(form.call_category==='digital' && !form.stb_work_type) return showToast('Please select work type');
    if(form.call_category==='broadband' && !form.bb_complaint_type) return showToast('Please select complaint type');
    setSubmitting(true);
    try {
      await supportCallAPI.create(form);
      setForm(emptyForm);
      setShowForm(false);
      showToast('Call log saved!');
      loadLogs(); loadStats();
    } catch(e) { showToast('Error: '+e.message); }
    setSubmitting(false);
  };

  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  return (
    <div style={{maxWidth:900,margin:'0 auto',padding:'16px'}}>
      {toast && <div style={{position:'fixed',top:20,right:20,background:'#1e293b',color:'#fff',padding:'10px 18px',borderRadius:'8px',zIndex:9999,fontSize:'13px'}}>{toast}</div>}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
        <div>
          <div style={{fontSize:'20px',fontWeight:'800',color:'#1e293b'}}>📞 Support Call Log</div>
          <div style={{fontSize:'12px',color:'#64748b',marginTop:'2px'}}>Digital & Broadband support calls</div>
        </div>
        {isCrm && <button style={{...btn,background:'#2563eb',color:'#fff'}} onClick={()=>setShowForm(p=>!p)}>
          {showForm?'✕ Cancel':'+ Log Call'}
        </button>}
      </div>

      {/* Stats */}
      {stats && (
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'10px',marginBottom:'16px'}}>
          {[
            {l:'Total Calls',v:stats.total,c:'#2563eb',bg:'#eff6ff'},
            {l:'Today',v:stats.today,c:'#16a34a',bg:'#f0fdf4'},
            {l:'Digital',v:stats.digital,c:'#7c3aed',bg:'#f5f3ff'},
            {l:'Broadband',v:stats.broadband,c:'#ea580c',bg:'#fff7ed'},
          ].map(s=>(
            <div key={s.l} style={{background:s.bg,borderRadius:'10px',padding:'12px',textAlign:'center'}}>
              <div style={{fontSize:'22px',fontWeight:'800',color:s.c}}>{s.v}</div>
              <div style={{fontSize:'10px',color:'#64748b',marginTop:'2px'}}>{s.l}</div>
            </div>
          ))}
        </div>
      )}

      {/* Log Call Form */}
      {isCrm && showForm && (
        <div style={card}>
          <div style={{fontWeight:'700',fontSize:'14px',marginBottom:'14px',color:'#1e293b'}}>📝 New Call Entry</div>

          {/* Category */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'}}>
            {['digital','broadband'].map(cat=>(
              <div key={cat} onClick={()=>f('call_category',cat)}
                style={{padding:'12px',borderRadius:'8px',border:'2px solid '+(form.call_category===cat?'#2563eb':'#e2e8f0'),
                  background:form.call_category===cat?'#eff6ff':'white',cursor:'pointer',textAlign:'center',fontWeight:600,fontSize:'13px'}}>
                {cat==='digital'?'📺 Digital (STB)':'🌐 Broadband'}
              </div>
            ))}
          </div>

          {/* Caller info */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'12px'}}>
            <div>
              <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>CALLER NAME</div>
              <input style={inp} value={form.caller_name} onChange={e=>f('caller_name',e.target.value)} placeholder="Customer name" />
            </div>
            <div>
              <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>MOBILE</div>
              <input style={inp} value={form.caller_mobile} onChange={e=>f('caller_mobile',e.target.value)} placeholder="Mobile number" />
            </div>
          </div>

          {/* Digital fields */}
          {form.call_category==='digital' && (
            <div style={{background:'#f8fafc',borderRadius:'8px',padding:'12px',marginBottom:'12px'}}>
              <div style={{fontSize:'11px',fontWeight:700,color:'#7c3aed',marginBottom:'8px'}}>📺 STB DETAILS</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'10px'}}>
                <div>
                  <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>STB ID / SERIAL</div>
                  <input style={inp} value={form.stb_id} onChange={e=>f('stb_id',e.target.value)} placeholder="STB ID or serial number" />
                </div>
                <div>
                  <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>WORK TYPE *</div>
                  <select style={sel} value={form.stb_work_type} onChange={e=>f('stb_work_type',e.target.value)}>
                    <option value="">Select work type</option>
                    {STB_WORK_TYPES.map(t=><option key={t.v} value={t.v}>{t.l}</option>)}
                  </select>
                </div>
              </div>
              {(form.stb_work_type==='migration_sub'||form.stb_work_type==='migration_lco') && (
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
                  <div>
                    <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>FROM {form.stb_work_type==='migration_lco'?'LCO':'SUB'}</div>
                    <input style={inp} value={form.stb_from} onChange={e=>f('stb_from',e.target.value)} placeholder="From..." />
                  </div>
                  <div>
                    <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>TO {form.stb_work_type==='migration_lco'?'LCO':'SUB'}</div>
                    <input style={inp} value={form.stb_to} onChange={e=>f('stb_to',e.target.value)} placeholder="To..." />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Broadband fields */}
          {form.call_category==='broadband' && (
            <div style={{background:'#f8fafc',borderRadius:'8px',padding:'12px',marginBottom:'12px'}}>
              <div style={{fontSize:'11px',fontWeight:700,color:'#ea580c',marginBottom:'8px'}}>🌐 BROADBAND DETAILS</div>
              <div style={{marginBottom:'10px'}}>
                <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>BMS USERNAME {bmsLooking&&<span style={{color:'#94a3b8'}}>Searching...</span>}</div>
                <input style={inp} value={form.bb_username}
                  onChange={e=>{f('bb_username',e.target.value); if(e.target.value.length>=3) lookupBmsUser(e.target.value);}}
                  onBlur={e=>lookupBmsUser(e.target.value)}
                  placeholder="Enter username to auto-fill details" />
              </div>
              {bmsUser && (
                <div style={{background:'#fff',border:'1px solid #bbf7d0',borderRadius:'8px',padding:'10px',marginBottom:'10px',fontSize:'12px'}}>
                  <div style={{fontWeight:700,color:'#15803d',marginBottom:'4px'}}>✅ Customer Found</div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'4px',color:'#475569'}}>
                    <div>👤 {bmsUser.name}</div>
                    <div>📱 {bmsUser.mobile}</div>
                    <div>📋 {bmsUser.plan}</div>
                    <div>🔰 {bmsUser.status}</div>
                    <div>🏘️ {bmsUser.sub_dist_code||'KB13'}</div>
                    <div>📡 LCO: {bmsUser.lco_code}</div>
                  </div>
                </div>
              )}
              <div>
                <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>COMPLAINT TYPE *</div>
                <select style={sel} value={form.bb_complaint_type} onChange={e=>f('bb_complaint_type',e.target.value)}>
                  <option value="">Select complaint type</option>
                  {BB_COMPLAINT_TYPES.map(t=><option key={t.v} value={t.v}>{t.l}</option>)}
                </select>
              </div>
            </div>
          )}

          {/* Notes */}
          <div style={{marginBottom:'12px'}}>
            <div style={{fontSize:'11px',fontWeight:600,color:'#64748b',marginBottom:'4px'}}>NOTES / WORK DONE</div>
            <textarea style={{...inp,height:'70px',resize:'vertical'}} value={form.notes} onChange={e=>f('notes',e.target.value)} placeholder="What was done / resolution..." />
          </div>

          {/* Follow up */}
          <div style={{display:'flex',alignItems:'center',gap:'16px',marginBottom:'14px'}}>
            <label style={{display:'flex',alignItems:'center',gap:'6px',cursor:'pointer',fontSize:'13px'}}>
              <input type="checkbox" checked={form.follow_up_needed} onChange={e=>f('follow_up_needed',e.target.checked)} />
              <span>Follow-up needed</span>
            </label>
            {form.follow_up_needed && (
              <input type="date" style={{...inp,width:'160px'}} value={form.follow_up_date} onChange={e=>f('follow_up_date',e.target.value)} />
            )}
            <label style={{display:'flex',alignItems:'center',gap:'6px',cursor:'pointer',fontSize:'13px'}}>
              <input type="checkbox" checked={form.resolved} onChange={e=>f('resolved',e.target.checked)} />
              <span>Resolved</span>
            </label>
          </div>

          <button style={{...btn,background:'#2563eb',color:'#fff'}} onClick={handleSubmit} disabled={submitting}>
            {submitting?'Saving...':'💾 Save Call Log'}
          </button>
        </div>
      )}

      {/* Filter */}
      <div style={{display:'flex',gap:'8px',marginBottom:'12px'}}>
        {['','digital','broadband'].map(cat=>(
          <button key={cat} onClick={()=>{setFilterCat(cat);setPage(1);}}
            style={{...btn,background:filterCat===cat?'#2563eb':'#f1f5f9',color:filterCat===cat?'#fff':'#475569',padding:'6px 14px',fontSize:'12px'}}>
            {cat===''?'All':cat==='digital'?'📺 Digital':'🌐 Broadband'}
          </button>
        ))}
        <div style={{marginLeft:'auto',fontSize:'12px',color:'#64748b',alignSelf:'center'}}>{total} records</div>
      </div>

      {/* Logs table */}
      <div style={card}>
        {logs.length===0 ? (
          <div style={{textAlign:'center',padding:'30px',color:'#64748b',fontSize:'13px'}}>No call logs yet. {isCrm&&'Click "+ Log Call" to add one.'}</div>
        ) : (
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'12px'}}>
              <thead><tr style={{background:'#f8fafc'}}>
                <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Date/Time</th>
                {!isCrm && <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Staff</th>}
                <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Type</th>
                <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Caller</th>
                <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Details</th>
                <th style={{padding:'8px 10px',textAlign:'left',fontWeight:600,color:'#64748b'}}>Notes</th>
                <th style={{padding:'8px 10px',textAlign:'center',fontWeight:600,color:'#64748b'}}>Status</th>
              </tr></thead>
              <tbody>
                {selectedLog && (
                  <tr style={{background:'#f0fdf4'}}>
                    <td colSpan={!isCrm?7:6} style={{padding:'12px 16px'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                        <div>
                          <div style={{fontWeight:700,fontSize:'12px',color:'#15803d',marginBottom:'6px'}}>📝 Full Notes — {selectedLog.staff_name} ({new Date(selectedLog.createdAt).toLocaleString('en-IN')})</div>
                          <div style={{fontSize:'13px',color:'#1e293b',whiteSpace:'pre-wrap',lineHeight:'1.5'}}>{selectedLog.notes||'No notes added'}</div>
                          {selectedLog.follow_up_needed && <div style={{marginTop:'8px',fontSize:'12px',color:'#dc2626'}}>📅 Follow-up needed: {selectedLog.follow_up_date?new Date(selectedLog.follow_up_date).toLocaleDateString('en-IN'):'-'}</div>}
                        </div>
                        <button onClick={()=>setSelectedLog(null)} style={{border:'none',background:'none',cursor:'pointer',fontSize:'18px',color:'#64748b'}}>✕</button>
                      </div>
                    </td>
                  </tr>
                )}
                {logs.map((log,i)=>{
                  const dt = new Date(log.createdAt);
                  const dtStr = dt.toLocaleDateString('en-IN')+' '+dt.toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'});
                  const isDigital = log.call_category==='digital';
                  const workLabel = isDigital ? STB_WORK_TYPES.find(t=>t.v===log.stb_work_type)?.l||log.stb_work_type
                    : BB_COMPLAINT_TYPES.find(t=>t.v===log.bb_complaint_type)?.l||log.bb_complaint_type;
                  return (
                    <tr key={log._id} onClick={()=>setSelectedLog(selectedLog?._id===log._id?null:log)} style={{borderTop:'1px solid #f1f5f9',background:selectedLog?._id===log._id?'#f0fdf4':i%2?'#f8fafc':'white',cursor:'pointer'}}>
                      <td style={{padding:'8px 10px',color:'#475569',whiteSpace:'nowrap'}}>{dtStr}</td>
                      {!isCrm && <td style={{padding:'8px 10px',fontWeight:600}}>{log.staff_name}</td>}
                      <td style={{padding:'8px 10px'}}>
                        <span style={{background:isDigital?'#f5f3ff':'#fff7ed',color:isDigital?'#7c3aed':'#ea580c',padding:'2px 8px',borderRadius:'4px',fontSize:'11px',fontWeight:600}}>
                          {isDigital?'📺 Digital':'🌐 Broadband'}
                        </span>
                      </td>
                      <td style={{padding:'8px 10px'}}>
                        <div style={{fontWeight:600}}>{log.caller_name||'-'}</div>
                        <div style={{color:'#64748b',fontSize:'11px'}}>{log.caller_mobile||''}</div>
                      </td>
                      <td style={{padding:'8px 10px'}}>
                        <div style={{fontSize:'11px',color:'#475569'}}>{workLabel}</div>
                        {isDigital && log.stb_id && <div style={{fontSize:'10px',color:'#64748b',fontFamily:'monospace'}}>STB: {log.stb_id}</div>}
                        {isDigital && log.stb_from && <div style={{fontSize:'10px',color:'#64748b'}}>{log.stb_from} → {log.stb_to}</div>}
                        {!isDigital && log.bb_username && <div style={{fontSize:'10px',color:'#64748b',fontFamily:'monospace'}}>User: {log.bb_username}</div>}
                        {log.follow_up_needed && <div style={{fontSize:'10px',color:'#dc2626',marginTop:'2px'}}>📅 Follow-up: {log.follow_up_date?new Date(log.follow_up_date).toLocaleDateString('en-IN'):'-'}</div>}
                      </td>
                      <td style={{padding:'8px 10px',color:'#475569',maxWidth:'180px'}}>
                        <div style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',fontSize:'11px'}}>{log.notes||'-'}</div>
                      </td>
                      <td style={{padding:'8px 10px',textAlign:'center'}}>
                        <span style={{background:log.resolved?'#dcfce7':'#fef2f2',color:log.resolved?'#16a34a':'#dc2626',padding:'2px 8px',borderRadius:'4px',fontSize:'10px',fontWeight:600}}>
                          {log.resolved?'✅ Done':'⏳ Pending'}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/* Pagination */}
            {total>20 && (
              <div style={{display:'flex',justifyContent:'center',gap:'8px',marginTop:'12px'}}>
                <button style={{...btn,background:'#f1f5f9',color:'#475569',padding:'5px 12px',fontSize:'12px'}} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                <span style={{fontSize:'12px',color:'#64748b',alignSelf:'center'}}>Page {page}</span>
                <button style={{...btn,background:'#f1f5f9',color:'#475569',padding:'5px 12px',fontSize:'12px'}} disabled={logs.length<20} onClick={()=>setPage(p=>p+1)}>Next →</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
